import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { DateAgoPipe } from 'src/app/pipes/date-ago.pipe';
import { BASE_CONFIG } from 'src/app/util/base-settings';
import { APP_ROUTES, COMPONENT_NAME, DATE_TIME_FORMAT } from 'src/app/util/constants';
import { DateFunctions } from 'src/app/util/date-functions';
import { UtilFunctions } from 'src/app/util/util';

@Component({
  selector: 'web-bill-list',
  templateUrl: './web-bill-list.component.html',
  styleUrls: ['./web-bill-list.component.scss'],
  providers: [DateAgoPipe]
})
export class WebBillListComponent implements OnInit {

  formattedList: any[] = [];
  currencyType: string = BASE_CONFIG.CURRENCY_SYMBOL;
  AppRoutes = APP_ROUTES;

  @Input() showLoading:boolean=false;
  @Input() billsList: any[] = [];
  @Input() billStatus: string = '';

  @Output() onSelectBill = new EventEmitter();

  constructor(
    private util: UtilFunctions,
    private dateFunctions: DateFunctions
  ) { }

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('ngOnChanges');
      if (changes.billsList && changes.billsList.currentValue) {
        this.toFormatBillsList();
      }
    } catch (error) {
      this.util.logFunc('ngOnChanges', error, COMPONENT_NAME.BILL_LIST_COMPONENT);
    }
  }

  onClickBill(bill: any)
  {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('onClickBill');
      this.onSelectBill.emit(bill);
    } catch (error) {
      this.util.logFunc('onClickBill', error, COMPONENT_NAME.BILL_LIST_COMPONENT);
    }
  }

  private toFormatBillsList() {
    try {
      if (BASE_CONFIG.IS_DEBUG) console.log('toFormatBillsList');
      for (let i = 0; i < this.billsList.length; i++) {
        this.billsList[i].date = this.dateFunctions.formatDate(this.billsList[i].bill_datetime, DATE_TIME_FORMAT.DATE);
        this.billsList[i].month = this.dateFunctions.formatDate(this.billsList[i].bill_datetime, DATE_TIME_FORMAT.MONTH);
        this.billsList[i].notes=this.billsList[i].bill.notes;
        if (this.billStatus == APP_ROUTES.UNPAID) {
          const dueDate: Date = new Date(this.dateFunctions.formatDate(this.billsList[i].bill_datetime, DATE_TIME_FORMAT.API_DATE_FORMAT1));
          const today: Date = new Date(this.dateFunctions.formatDate(new Date(), DATE_TIME_FORMAT.API_DATE_FORMAT1));
          if (dueDate < today) {
            this.billsList[i].isOverDue = true;
          } else {
            this.billsList[i].isOverDue = false;
          }
        }
      }
      this.formattedList = this.util.cloneDeep(this.billsList.sort((a, b) => (new Date(a.bill_datetime) > new Date(b.bill_datetime)) ? 1 : -1));
    } catch (error) {
      this.util.logFunc('onClickBill', error, COMPONENT_NAME.BILL_LIST_COMPONENT);
    }
  }

}
